import { useEffect, useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
//import {ReactComponent as Logo} from '../../../assets/images/arrow_logo.svg';
//import {ReactComponent as Logo} from '../../../assets/images/ugcan-logo.svg';
import { ReactComponent as Logo } from '../../../assets/images/ugcan_logo_V3.svg';
//import { Button } from "@material-tailwind/react";
import { RightBurgerMenu } from "./BurgerMenu";
import { useNavigate } from 'react-router-dom';
//import CandidateLogin from '../../Authentication/CandidateLogin'; 
import { useUser } from "../../store/UserContext";
import { clearTokens } from '../../Authentication/auth';

export function NavBar() {
  const { user, setUser } = useUser(); 
  console.log(user)
  const [showLoginBox, setShowLoginBox] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  const navCSS =  `px-2 sm:px-3 py-1 sm:py-1.5 normal-case text-xs sm:text-sm text-primary-900 font-bold
                  tracking-wider shadow-none rounded-sm bg-white 
                  hover:border-2 hover:border-primary-900 hover:shadow-md hover:rounded-md
                  transition-all duration-200`
  const buttonClass = `m-1 sm:m-2 p-1.5 sm:p-2 
                  bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 
                  text-xs sm:text-sm font-bold normal-case items-center
                  transition-all duration-200`

  const navList = (
    <ul className="flex flex-wrap text-center gap-1 sm:gap-x-2 justify-center">
      <li className={`${navCSS}`}>
        <Link to="/">Home</Link>
      </li>
      <li className={`${navCSS}`}>
        <Link to="/overview">About</Link>
      </li>
      <li className={`${navCSS}`}>
        <Link to="/features">Features</Link>
      </li>
      {user && (
        <Fragment>
          <li className={`${navCSS}`}>
            <Link to="/dashboard">Dashboard</Link>
          </li>
          <li className={`${navCSS}`}>
            <Link to="/student-dashboard">Student Dashboard</Link>
          </li>
        </Fragment>
      )}
      <li className={`${navCSS}`}>
        <Link to="/cetzone">CET Zone</Link>
      </li>
      <li className={`${navCSS}`}>
        <Link to="/capzone">CAP Zone</Link>
      </li>
      <li className={`${navCSS}`}>
        <Link to="/prediction">Seat Predictor</Link>{" "}
      </li> 
      {/* <li className={`${navCSS}`}>
        <Link to="/community">Forum</Link>{" "}
      </li> */}
      {/* <li className={`${navCSS}`}>
        <Link to="/pricing">Pricing</Link>
      </li> */}
      <li className={`${navCSS}`}>
        <Link to="/contactus">Contact</Link>
      </li>
    </ul>
  );

  const handleLogout = () => {
    clearTokens();
    setUser(null);
    navigate('/'); // Make sure useNavigate is imported and called inside a component
  };

  useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960
    );
  }, []);
  
  console.log(user);
  return (
    <div>
      <nav className="p-0 border-b shadow-md border-gray-200 bg-white">
        <div className="relative flex items-center justify-between mx-auto min-h-14 sm:min-h-16 px-2 sm:px-4">
          {/* Logo - Mobile and Desktop */}
          <div className="flex items-center pl-2 sm:pl-4 z-10 flex-shrink-0">
            <div className="w-24 sm:w-32 md:w-40">
              <Logo className="w-full h-auto" />
            </div>
          </div>
          
          {/* Desktop Navigation - Hidden on mobile */}
          <div className="hidden md:block text-center flex-1 mx-4">
            <div className="flex space-x-2 items-center justify-center mt-1 mb-1">{navList}</div>
            <h4 className="italic text-xs font-bold text-secondary-500 mt-1">
              College Avenue is for everyone who is keen on choosing the best possible colleges for undergraduate study
            </h4>
          </div>

          {/* Burger Menu - Visible only on mobile and tablet, hidden on desktop */}
          <div className="flex md:hidden items-center pr-2 sm:pr-4 z-10 flex-shrink-0">
            <RightBurgerMenu />
          </div>

          {/* User Avatar / Login - Currently commented out */}
          {/* {user ? (
            <UserAvatar user_name={user?.username} user_color={user?.colorhex} />
          ) : (
            <div className="hidden md:flex flex-row gap-x-2 items-center text-center justify-center m-2">
              <div className="flex items-center justify-end space-x-2">
                <Button data-cy='login-signup' onClick={() => setShowLoginBox(true)} className={`${buttonClass}`}>
                  Log In / Sign Up
                </Button>
              </div>
              {showLoginBox && (
                <CandidateLogin closeModal={()=> {
                  setShowLoginBox(false);
                }}/>
              )}
            </div>
          )} */}
        </div>  
      </nav>
    </div>
  );
}
